import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import loadable from '@loadable/component';

import { bool, object } from 'prop-types';
import { compose } from 'redux';
import { connect, useDispatch } from 'react-redux';

// import { camelize } from '../../util/string';
import { propTypes } from '../../util/types';

// import FallbackPage from './FallbackPage';
// import { ASSET_NAME } from './LandingPage.duck';
import {
  AvatarMedium,
  H4,
  InlineTextButton,
  NamedLink,
  Page,
  PrimaryButton,
  ResponsiveImage,
} from '../../components';
import NewListingCard from '../../components/NewListingCard/NewListingCard';
import LandingPageSkeleton, {
  LandingListingRowSkeleton,
  LandingTopSellersSkeleton,
  LandingExploreGridSkeleton,
} from '../../components/LandingPageSkeleton/LandingPageSkeleton';
import classNames from 'classnames';
import TopbarContainer from '../TopbarContainer/TopbarContainer';
import { FormattedMessage, useIntl } from 'react-intl';
import { useConfiguration } from '../../context/configurationContext';
import FooterComponent from '../FooterContainer/FooterContainer';
import css from './newLandingPage.module.css';
import SectionContainer from '../PageBuilder/SectionBuilder/SectionContainer';

// import { getListingsById } from '../../ducks/marketplaceData.duck';
import { withRouter } from 'react-router-dom/cjs/react-router-dom';
import { useRouteConfiguration } from '../../context/routeConfigurationContext';
import { createResourceLocatorString } from '../../util/routes';
import { FaStar } from 'react-icons/fa';
import { MdKeyboardArrowRight } from 'react-icons/md';
import { FaChevronLeft, FaChevronRight } from 'react-icons/fa6';

const SlickSlider = loadable(() => import('react-slick'));

let slickPreloadPromise;
let slickReady = false;
const slickReadyCallbacks = [];

const preloadSlickOnce = () => {
  if (!slickPreloadPromise) {
    slickPreloadPromise = Promise.resolve(SlickSlider.preload()).then(() => {
      slickReady = true;
      slickReadyCallbacks.forEach(cb => cb());
      slickReadyCallbacks.length = 0;
    });
  }
  return slickPreloadPromise;
};

const Carousel = props => {
  const { children, className, ...sliderProps } = props;
  const [ready, setReady] = useState(slickReady);

  useEffect(() => {
    if (slickReady) {
      setReady(true);
      return;
    }

    const callback = () => setReady(true);
    slickReadyCallbacks.push(callback);
    preloadSlickOnce();

    return () => {
      const idx = slickReadyCallbacks.indexOf(callback);
      if (idx > -1) slickReadyCallbacks.splice(idx, 1);
    };
  }, []);

  return ready ? (
    <SlickSlider className={className} {...sliderProps}>
      {children}
    </SlickSlider>
  ) : (
    <div className={classNames(css.carouselFallback, className)}>{children}</div>
  );
};

const useInViewOnce = (options = {}) => {
  const { rootMargin = '200px', threshold = 0, disabled = false } = options;
  const ref = useRef(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    if (disabled) {
      if (!isVisible) setIsVisible(true);
      return;
    }
    if (isVisible) return;
    const element = ref.current;
    if (!element) return;

    if (typeof IntersectionObserver === 'undefined') {
      setIsVisible(true);
      return;
    }

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.disconnect();
        }
      },
      { rootMargin, threshold }
    );

    observer.observe(element);
    return () => observer.disconnect();
  }, [disabled, isVisible, rootMargin, threshold]);

  return [ref, isVisible];
};

const RenderWhenVisible = props => {
  const { children, rootMargin = '200px', minHeight, disabled = false } = props;
  const [ref, isVisible] = useInViewOnce({ rootMargin, disabled });

  return (
    <div ref={ref} style={minHeight ? { minHeight } : null}>
      {isVisible ? children : null}
    </div>
  );
};

import { addToLikeList } from '../../ducks/user.duck';
import {
  customPriceFilterListings,
  fetchExploreFeed,
  fetchTopSellers,
  fetchTrendingListings,
} from './newLandingPage.duck';
import { findLikedLists } from '../SearchPage/SearchPage.duck';
import { toCdnImageUrl } from '../../util/imageCdn';

const NextArrow = React.memo(props => {
  const { className, style, onClick } = props;
  return (
    <div
      className={className}
      style={{
        ...style,
        zIndex: 5,
      }}
      onClick={onClick}
    >
      <FaChevronRight />
    </div>
  );
});

const PrevArrow = React.memo(props => {
  const { className, style, onClick } = props;
  return (
    <div
      className={className}
      style={{
        ...style,
        zIndex: 5,
      }}
      onClick={onClick}
    >
      <FaChevronLeft />
    </div>
  );
});

// const PageBuilder = loadable(() =>
//   import(/* webpackChunkName: "PageBuilder" */ '../PageBuilder/PageBuilder')
// );

function DesignedImagerWrapper(props) {
  const {
    intl,
    firstBtn,
    secondBtn,
    onSubmitFirst,
    onSubmitSecond,
    title,
    description,
    heroData,
    content,
    fieldType,
    href,
    history,
  } = props;

  const imageUrl = heroData?.appearance?.backgroundImage;

  const variants = imageUrl?.attributes?.variants || {};

  return (
    <div className={css.imageWrapper}>
      <ResponsiveImage
        rootClassName={css.rootForImage}
        alt={'Kloset Klub - Rent and Lend Fashion'}
        image={imageUrl}
        variants={variants ? Object.keys(variants) : []}
        loading="eager"
        fetchpriority="high"
      />
      {/* <img
        src={HERO_IMAGE_URL}
        fetchpriority="high"
        loading="eager"
        decoding="async"
        alt="Kloset Klub - Rent and Lend Fashion"
        width="1920"
        height="800"
      /> */}
      <div className={css.headerContentContainer}>
        <div className={css.headerContainer}>
          {title && <h1 className={css.bannerTitle}>{title}</h1>}

          {description && <p className={css.bannerDescription}>{description}</p>}
          {/* {title && <H4 as="h2">{intl.formatMessage({ id: title })}</H4>} */}
          {/* {title && <H4 as="h2">{intl.formatMessage({ id: title })}</H4>} */}
          <div className={css.ctaContainer}>
            {/* <PrimaryButton
              onClick={() => onSubmitFirst('CreateListingPage')}
              className={css.headingBtn}
            >
              {intl.formatMessage({ id: firstBtn })}
            </PrimaryButton> */}
            {fieldType === 'internalButtonLink' ? (
              <PrimaryButton onClick={() => history.push(href)} className={css.headingBtn}>
                {content}
              </PrimaryButton>
            ) : (
              <PrimaryButton
                onClick={() => onSubmitSecond('SearchPage')}
                className={css.headingBtn}
              >
                {intl.formatMessage({ id: secondBtn })}
              </PrimaryButton>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

const ShowMoreRedirectSearchButton = React.memo(
  ({ params = {}, extra, history, routeConfiguration }) => (
    <InlineTextButton
      onClick={() =>
        extra
          ? history.push({
              pathname: createResourceLocatorString('SearchPage', routeConfiguration, {}, params),
              ...extra,
            })
          : history.push(createResourceLocatorString('SearchPage', routeConfiguration, {}, params))
      }
    >
      <FormattedMessage id="LandingPage.brandsCta" />
      <MdKeyboardArrowRight />
    </InlineTextButton>
  )
);

const Empty = React.memo(({ textId }) => (
  <div className={css.emptyDiv}>
    <FormattedMessage id={textId} />
  </div>
));

export const NewLandingPageComponent = props => {
  const {
    trendingListings,
    filteredListings,
    recentListings,
    qualityCheckedListings,
    exploreFeed,
    history,
    topSellers,
    favroiteListingIds,
    onAddList,
    pageAssetsData,
    inProgress,
    allInProgress,
    trendingInProgress,
    recentInProgress,
    qualityCheckedInProgress,
    underFilterInProgress,
    topSellersInProgress,
    exploreFeedInProgress,
  } = props;

  const dispatch = useDispatch();

  const config = useConfiguration();

  const landingPageAssetData = pageAssetsData?.landingPage?.data || {};
  const sections = landingPageAssetData?.sections || [];

  const heroData = sections.find(s => s?.sectionType === 'hero');
  const description = heroData?.description?.content || '';
  const callToAction = heroData?.callToAction || {};
  const title = heroData?.title?.content || '';

  const { content, fieldType, href } = callToAction || {};

  const routeConfiguration = useRouteConfiguration();
  const intl = useIntl();
  // const { routeName, pathParams } = getSearchPageResourceLocatorStringParams(
  //   routeConfiguration,
  //   location
  // );

  const schemaTitleVars = {
    marketplaceName: config.marketplaceName,
    tagLine: intl.formatMessage({ id: 'LandingPage.metaTagLine' }),
  };
  const schemaTitle = intl.formatMessage({ id: 'LandingPage.metaTitle' }, schemaTitleVars);

  const schema = useMemo(
    () => ({
      '@context': 'http://schema.org',
      '@type': 'WebPage',
      name: schemaTitle,
      description: intl.formatMessage({ id: 'LandingPage.metaDescription' }),
    }),
    [schemaTitle, intl]
  );

  // Deduplicate listings across sections.
  // Priority: QUALITY CHECKED → JUST LISTED → TRENDING THIS WEEK → UNDER 700
  // A listing that already appears in an earlier section is excluded from later ones.
  const seenInQualityChecked = useMemo(
    () => new Set((qualityCheckedListings || []).map(l => l.id.uuid)),
    [qualityCheckedListings]
  );

  const uniqueRecentListings = useMemo(
    () => (recentListings || []).filter(l => !seenInQualityChecked.has(l.id.uuid)),
    [recentListings, seenInQualityChecked]
  );

  const seenInQCAndRecent = useMemo(
    () => new Set([...seenInQualityChecked, ...uniqueRecentListings.map(l => l.id.uuid)]),
    [seenInQualityChecked, uniqueRecentListings]
  );

  const uniqueTrendingListings = useMemo(
    () => (trendingListings || []).filter(l => !seenInQCAndRecent.has(l.id.uuid)),
    [trendingListings, seenInQCAndRecent]
  );

  const seenInAllBeforeFiltered = useMemo(
    () => new Set([...seenInQCAndRecent, ...uniqueTrendingListings.map(l => l.id.uuid)]),
    [seenInQCAndRecent, uniqueTrendingListings]
  );

  const uniqueFilteredListings = useMemo(
    () => (filteredListings || []).filter(l => !seenInAllBeforeFiltered.has(l.id.uuid)),
    [filteredListings, seenInAllBeforeFiltered]
  );

  const [trendingRef, showTrending] = useInViewOnce({ rootMargin: '200px' });
  useEffect(() => {
    if (showTrending && !trendingListings?.length) {
      dispatch(fetchTrendingListings(config)).then(res => {
        if (res?.length) dispatch(findLikedLists(res.map(l => l.id)));
      });
    }
  }, [showTrending]);

  const [sellerRef, showSeller] = useInViewOnce({ rootMargin: '300px' });

  useEffect(() => {
    if (showSeller && !topSellers?.length) {
      dispatch(fetchTopSellers(config));
    }
  }, [showSeller]);

  const [underRef, showUnder] = useInViewOnce({ rootMargin: '400px' });

  useEffect(() => {
    if (showUnder && !filteredListings?.length) {
      dispatch(customPriceFilterListings(config)).then(res => {
        if (res?.length) dispatch(findLikedLists(res.map(l => l.id)));
      });
    }
  }, [showUnder]);

  const [exploreRef, showExplore] = useInViewOnce({ rootMargin: '500px' });

  useEffect(() => {
    if (showExplore && !exploreFeed?.length) {
      dispatch(fetchExploreFeed(config)).then(res => {
        if (res?.length) dispatch(findLikedLists(res.map(l => l.id)));
      });
    }
  }, [showExplore]);

  // Avoid reading window during render (SSR/hydration + perf).
  const [viewport, setViewport] = useState('desktop');
  useEffect(() => {
    if (typeof window === 'undefined') return;

    let rafId = null;
    const computeViewport = width => {
      if (width < 768) return 'mobile';
      if (width < 992) return 'tablet';
      return 'desktop';
    };

    const onResize = () => {
      if (rafId) return;
      rafId = window.requestAnimationFrame(() => {
        rafId = null;
        setViewport(computeViewport(window.innerWidth));
      });
    };

    setViewport(computeViewport(window.innerWidth));
    window.addEventListener('resize', onResize, { passive: true });
    return () => {
      if (rafId) window.cancelAnimationFrame(rafId);
      window.removeEventListener('resize', onResize);
    };
  }, []);

  const nextArrowMemo = useMemo(() => <NextArrow />, []);
  const prevArrowMemo = useMemo(() => <PrevArrow />, []);

  const createSettings = useCallback(
    ({ mobile, tablet, desktop }) => {
      const initial = viewport === 'mobile' ? mobile : viewport === 'tablet' ? tablet : desktop;
      const showArrows = viewport === 'desktop';

      return {
        lazyLoad: 'ondemand',
        infinite: false,
        speed: 500,
        swipeToSlide: true,
        nextArrow: nextArrowMemo,
        prevArrow: prevArrowMemo,
        arrows: showArrows,
        slidesToShow: initial.slidesToShow,
        slidesToScroll: initial.slidesToScroll,
        responsive: [
          {
            breakpoint: 767,
            settings: { ...mobile, arrows: false },
          },
          {
            breakpoint: 991,
            settings: { ...tablet, arrows: false },
          },
          {
            breakpoint: 9999,
            settings: { ...desktop, arrows: true },
          },
        ],
      };
    },
    [viewport, nextArrowMemo, prevArrowMemo]
  );

  const settings = useMemo(
    () =>
      createSettings({
        mobile: { slidesToShow: 2.2, slidesToScroll: 1 },
        tablet: { slidesToShow: 3.2, slidesToScroll: 2 },
        desktop: { slidesToShow: 4.2, slidesToScroll: 4 },
      }),
    [createSettings]
  );

  const topSellersSettings = useMemo(
    () =>
      createSettings({
        mobile: { slidesToShow: 1.2, slidesToScroll: 1 },
        tablet: { slidesToShow: 2.2, slidesToScroll: 2 },
        desktop: { slidesToShow: 3.2, slidesToScroll: 2 },
      }),
    [createSettings]
  );

  const draftId = '00000000-0000-0000-0000-000000000000';
  const createListingLinkConfig = useMemo(
    () => ({
      group: 'primary',
      text: intl.formatMessage({ id: 'TopbarDesktop.createListing' }),
      type: 'internal',
      route: {
        name: 'EditListingPage',
        params: { slug: 'draft', id: draftId, type: 'new', tab: 'details' },
      },
      highlight: true,
    }),
    [intl]
  );

  const handleRedirect = useCallback(
    page => {
      if (page === 'SearchPage') {
        history.push(createResourceLocatorString('SearchPage', routeConfiguration, {}, {}));
      } else if (page === 'CreateListingPage') {
        const {
          route: { name, params },
        } = createListingLinkConfig;
        history.push(createResourceLocatorString(name, routeConfiguration, params));
      }
    },
    [createListingLinkConfig, history, routeConfiguration]
  );

  // console.log(3434, config);

  const showInitialSkeleton = inProgress && !pageAssetsData;
  if (showInitialSkeleton) {
    return (
      <Page schema={schema} title={schemaTitle} className={css.page}>
        <TopbarContainer />
        <LandingPageSkeleton />
        <FooterComponent />
      </Page>
    );
  }

  return (
    <Page
      schema={schema}
      title={schemaTitle}
      description={intl.formatMessage({
        id: 'LandingPage.metaDescription',
      })}
      className={css.page}
    >
      <TopbarContainer />
      <div className={css.mainContainer} role="main">
        {/* <div className={css.mobileTabsWrapper}>
          <div className={css.shopLabelWrapper}>
            <span className={css.shopLabel}>SHOP</span>
          </div>
          <div className={css.mobileTabs}>
            <button
              className={classNames(css.tabBtn, { [css.activeTab]: activeTab === 'women' })}
              onClick={() => setActiveTab('women')}
            >
              WOMEN
            </button>
            <div className={css.tabDivider} />
            <button
              className={classNames(css.tabBtn, { [css.activeTab]: activeTab === 'men' })}
              onClick={() => setActiveTab('men')}
            >
              MEN
            </button>
          </div>
        </div> */}

        {/* <SectionContainer className={css.section1}> */}
        {/* <div className={classNames(css.header, css.section)}> */}
        <SectionContainer className={css.section1}>
          <div className={classNames(css.section)}>
            <DesignedImagerWrapper
              firstBtn={'LandingPage.headerctaButtonSell'}
              secondBtn={'LandingPage.headerctaButtonShop'}
              onSubmitFirst={handleRedirect}
              onSubmitSecond={handleRedirect}
              intl={intl}
              heroData={heroData}
              content={content}
              fieldType={fieldType}
              href={href}
              history={history}
              title={title}
              description={description}
            />
          </div>
        </SectionContainer>

        <div className={css.listFirstItemWrapper}>
          <button
            className={css.listFirstItemBtn}
            onClick={() => handleRedirect('CreateListingPage')}
          >
            <FormattedMessage id="LandingPage.listFirstItemBtn" />
          </button>
        </div>

        <SectionContainer className={classNames(css.hotSection, css.section1)}>
          <div className={css.hotSectionHeader}>
            <H4 className={css.h2} as="h2">
              <FormattedMessage id="LandingPage.sectionHeadingQualityChecked" />
            </H4>
            <ShowMoreRedirectSearchButton
              params={{ meta_isConsignment: 'true' }}
              history={history}
              routeConfiguration={routeConfiguration}
            />
          </div>
          <div>
            {qualityCheckedInProgress || qualityCheckedListings == null || (allInProgress && qualityCheckedListings.length === 0) ? (
              <LandingListingRowSkeleton />
            ) : qualityCheckedListings.length === 0 ? (
              <Empty textId={'LandingPage.emptyQualityCheckedLists'} />
            ) : (
              <div className={classNames('slider-container', css.sliderContainerMinHeight)}>
                <Carousel className={css.sliderForListingCards} {...settings}>
                  {qualityCheckedListings.map(listing => {
                    const isLiked = favroiteListingIds && favroiteListingIds.has(listing.id.uuid);
                    return (
                      <div key={listing?.id?.uuid} className={css.listingCard}>
                        <NewListingCard
                          rootClassName={classNames(css.indivCard, css.reduceShadow)}
                          history={history}
                          listing={listing}
                          isLiked={isLiked}
                          showAuthorInfo={false}
                          showListingName={false}
                          showRating={false}
                          showTimeBadge={true}
                          onAddList={onAddList}
                        />
                      </div>
                    );
                  })}
                </Carousel>
              </div>
            )}
          </div>
        </SectionContainer>

        <SectionContainer className={classNames(css.hotSection, css.section1)}>
          <div className={css.hotSectionHeader}>
            <H4 className={css.h2} as="h2">
              <FormattedMessage id="LandingPage.sectionHeadingJustListed" />
            </H4>
            <ShowMoreRedirectSearchButton
              params={{ sort: 'createdAt' }}
              history={history}
              routeConfiguration={routeConfiguration}
            />
          </div>
          <div>
            {recentInProgress || recentListings == null || (allInProgress && recentListings.length === 0) ? (
              <LandingListingRowSkeleton />
            ) : uniqueRecentListings.length === 0 ? (
              <Empty textId={'LandingPage.emptyHotLists'} />
            ) : (
              <div className={classNames('slider-container', css.sliderContainerMinHeight)}>
                <Carousel className={css.sliderForListingCards} {...settings}>
                  {uniqueRecentListings.map(listing => {
                    const isLiked = favroiteListingIds && favroiteListingIds.has(listing.id.uuid);
                    return (
                      <div key={listing?.id?.uuid} className={css.listingCard}>
                        <NewListingCard
                          rootClassName={classNames(css.indivCard, css.reduceShadow)}
                          history={history}
                          listing={listing}
                          isLiked={isLiked}
                          showAuthorInfo={false}
                          showListingName={false}
                          showRating={false}
                          showTimeBadge={true}
                          onAddList={onAddList}
                        />
                      </div>
                    );
                  })}
                </Carousel>
              </div>
            )}
          </div>
        </SectionContainer>

        <div ref={trendingRef} style={!showTrending ? { minHeight: 420 } : undefined}>
          {showTrending && (
            <SectionContainer className={css.hotSection}>
              <div className={css.hotSectionHeader}>
                <H4 className={css.h2} as="h2">
                  <FormattedMessage id="LandingPage.sectionHeadingTrending" />
                </H4>
                <ShowMoreRedirectSearchButton
                  params={{ sort: 'meta_trendingScore' }}
                  history={history}
                  routeConfiguration={routeConfiguration}
                />
              </div>
              {trendingInProgress || trendingListings == null ? (
                <LandingListingRowSkeleton />
              ) : uniqueTrendingListings.length === 0 ? (
                <Empty textId={'LandingPage.emptyTrendingLists'} />
              ) : (
                <div className={classNames('slider-container', css.sliderContainerMinHeight)}>
                  <Carousel className={css.sliderForListingCards} {...settings}>
                    {uniqueTrendingListings
                      // .slice()
                      // .reverse()
                      .map(listing => {
                        const isLiked =
                          favroiteListingIds && favroiteListingIds.has(listing.id.uuid);
                        return (
                          <div key={listing?.id?.uuid} className={css.listingCard}>
                            <NewListingCard
                              className={classNames(css.indivCard, css.reduceShadow)}
                              history={history}
                              isLiked={isLiked}
                              listing={listing}
                              showAuthorInfo={false}
                              showListingName={false}
                              showRating={false}
                              onAddList={onAddList}
                            />
                          </div>
                        );
                      })}
                  </Carousel>
                </div>
              )}
            </SectionContainer>
          )}
        </div>

        <div ref={sellerRef} style={!showSeller ? { minHeight: 320 } : undefined}>
          {showSeller && (
            <SectionContainer className={css.hotSection}>
              <H4 className={classNames(css.h2, css.h2padleft)} as="h2">
                <FormattedMessage id="LandingPage.sectionHeadingTopSellers" />
              </H4>
              {topSellersInProgress || topSellers == null ? (
                <LandingTopSellersSkeleton />
              ) : topSellers.length === 0 ? (
                <Empty textId={'LandingPage.klubPicksLists'} />
              ) : (
                <div className="slider-container">
                  <Carousel
                    className={classNames(css.klubPickSlider, css.sliderForKlubCards, {
                      [css.lessContent]: topSellers.length < 4,
                    })}
                    {...topSellersSettings}
                  >
                    {topSellers.map(user => {
                      const { id, publicData, stats, profile } = user;
                      const urlParams = publicData.profileUrl
                        ? {
                            name: 'ProfilePageByUsername',
                            params: { userName: publicData.profileUrl },
                          }
                        : { name: 'ProfilePage', params: { id: id.uuid } };
                      return (
                        <NamedLink key={id.uuid} {...urlParams} className={css.klubPicksCard}>
                          <div>
                            <div className={css.headerDiv}>
                              <AvatarMedium
                                disableProfileLink
                                user={{
                                  ...user,
                                  attributes: {
                                    profile: user.profile,
                                    banned: false,
                                    deleted: false,
                                  },
                                }}
                              />
                              <div className={css.stats}>
                                <p>
                                  <strong>{stats.totalListings}</strong>
                                  <FormattedMessage id="ProfilePage.headingStatListings" />
                                </p>
                                <p>
                                  <strong>{stats.likesCount}</strong>{' '}
                                  <FormattedMessage id="ProfilePage.headingStatLikes" />
                                </p>
                                <p>
                                  <strong>{stats.followCount}</strong>
                                  <FormattedMessage id="ProfilePage.headingStatFollowers" />
                                </p>
                              </div>
                            </div>
                            <div className={css.secondaryHead}>
                              <H4 as="h3" className={classNames(css.profUrl, css.h3)}>
                                {publicData?.rawProfileUrl?.toUpperCase() ||
                                  publicData?.profileUrl?.toUpperCase()}
                              </H4>
                              {profile.metadata?.rating && profile.metadata?.ratingCount && (
                                <div className={css.rating}>
                                  <span className={css.ratingValue}>
                                    <span>{profile.metadata?.rating ?? 0}</span>
                                    <FaStar />
                                  </span>
                                  <span className={css.ratingCount}>
                                    ({profile.metadata?.ratingCount ?? 0})
                                  </span>
                                </div>
                              )}
                            </div>
                            <p dangerouslySetInnerHTML={{ __html: profile.bio }}></p>
                          </div>
                        </NamedLink>
                      );
                    })}
                  </Carousel>
                </div>
              )}
            </SectionContainer>
          )}
        </div>

        <div ref={underRef} style={!showUnder ? { minHeight: 420 } : undefined}>
          {showUnder && (
            <SectionContainer className={css.hotSection}>
              <div className={css.hotSectionHeader}>
                <H4 className={css.h2} as="h2">
                  {intl.formatMessage({ id: 'LandingPage.sectionHeadingPriceUnder' }).toUpperCase()}
                </H4>
                <ShowMoreRedirectSearchButton
                  params={{ price: '0,700' }}
                  history={history}
                  routeConfiguration={routeConfiguration}
                />
              </div>
              {underFilterInProgress || filteredListings == null ? (
                <LandingListingRowSkeleton />
              ) : uniqueFilteredListings.length === 0 ? (
                <Empty textId={'LandingPage.underFilterLists'} />
              ) : (
                <div className={classNames('slider-container', css.sliderContainerMinHeight)}>
                  <Carousel className={css.sliderForListingCards} {...settings}>
                    {uniqueFilteredListings.map(listing => {
                      const isLiked = favroiteListingIds && favroiteListingIds.has(listing.id.uuid);
                      return (
                        <div key={listing?.id?.uuid} className={css.listingCard}>
                          <NewListingCard
                            className={classNames(css.indivCard, css.reduceShadow)}
                            history={history}
                            isLiked={isLiked}
                            listing={listing}
                            showAuthorInfo={false}
                            showListingName={false}
                            showRating={false}
                            onAddList={onAddList}
                          />
                        </div>
                      );
                    })}
                  </Carousel>
                </div>
              )}
            </SectionContainer>
          )}
        </div>

        <div ref={exploreRef} style={!showExplore ? { minHeight: 400 } : undefined}>
          {showExplore && (
            <SectionContainer className={css.hotSection}>
              <H4 className={css.h2} as="h2">
                <span className={css.discoveryFeedHeading}>
                  <FormattedMessage id="LandingPage.sectionHeadingDiscoveryFeed" />
                </span>
              </H4>
              {exploreFeedInProgress || exploreFeed == null ? (
                <LandingExploreGridSkeleton />
              ) : exploreFeed.length === 0 ? (
                <Empty textId={'LandingPage.emptyExploreFeed'} />
              ) : (
                <div className={css.productGrid}>
                  {exploreFeed.map(listing => {
                    const isLiked = favroiteListingIds && favroiteListingIds.has(listing.id.uuid);
                    return (
                      <div key={listing?.id?.uuid} className={css.gridListingCard}>
                        <NewListingCard
                          className={classNames(css.indivCard, css.reduceShadow)}
                          history={history}
                          isLiked={isLiked}
                          listing={listing}
                          showAuthorInfo={false}
                          showListingName={false}
                          showRating={false}
                          onAddList={onAddList}
                        />
                      </div>
                    );
                  })}
                </div>
              )}
            </SectionContainer>
          )}
        </div>

        {/* <SectionContainer className={css.section}>
          <H4 className={css.h2} as="h2">
            {intl.formatMessage({ id: 'LandingPage.sectionHeadingGetApp' })}
          </H4>
          <div className={classNames(css.header, css.section)}>
            <DesignedImagerWrapper
              img={
                toCdnImageUrl(
                  'https://sharetribe-assets.imgix.net/682b2a43-8956-498d-a33e-423c315917ca/raw/b8/2e372aafdbfec627c8e9e04d3912dedff7ce58?auto=format&fit=clip&h=2400&w=2400&s=794c490604c51f1e9f5517c1253db8dd'
                )
              }
              className={css.imageWrapper}
              onSubmitFirst={() => console.log('android click')}
              onSubmitSecond={() => console.log('apple click')}
              intl={intl}
              title={'LandingPage.finalSectionHeading'}
              firstBtn={'LandingPage.androidAppCtaBtnText'}
              secondBtn={'LandingPage.appleAppCtaBtnText'}
            />
          </div>
        </SectionContainer> */}
      </div>
      <FooterComponent />
    </Page>
  );
};

NewLandingPageComponent.propTypes = {
  pageAssetsData: object,
  inProgress: bool,
  error: propTypes.error,
};

const mapStateToProps = state => {
  const { pageAssetsData, inProgress, error } = state.hostedAssets || {};
  const {
    trendingListings,
    recentListings,
    qualityCheckedListings,
    underFilterListings,
    topSellers,
    exploreFeed,
    allInProgress,
    trendingInProgress,
    recentInProgress,
    qualityCheckedInProgress,
    underFilterInProgress,
    topSellersInProgress,
    exploreFeedInProgress,
  } = state.NewLandingPage;
  const { favroiteListingIds } = state.SearchPage;
  return {
    pageAssetsData,
    inProgress,
    error,
    trendingListings,
    recentListings,
    qualityCheckedListings,
    filteredListings: underFilterListings,
    topSellers,
    exploreFeed,
    favroiteListingIds,
    allInProgress,
    trendingInProgress,
    recentInProgress,
    qualityCheckedInProgress,
    underFilterInProgress,
    topSellersInProgress,
    exploreFeedInProgress,
  };
};

const mapDispatchToProps = dispatch => ({
  onAddList: (listingId, authorId) => dispatch(addToLikeList(listingId, authorId)),
});

// Note: it is important that the withRouter HOC is **outside** the
// connect HOC, otherwise React Router won't rerender any Route
// components since connect implements a shouldComponentUpdate
// lifecycle hook.
//
// See: https://github.com/ReactTraining/react-router/issues/4671
const NewLandingPage = compose(
  withRouter,
  connect(mapStateToProps, mapDispatchToProps)
)(NewLandingPageComponent);

export default NewLandingPage;
